exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "li a[_v-bb45f604]:hover{background:none}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-bb45f604&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Header.vue
 ** module id = 36
 ** module chunks = 0
 **/